const fileNameToSafeString = (fileName: string) => fileName.replace(/[^a-z0-9_\-.]/gi, '_').toLowerCase();

// eslint-disable-next-line arca/no-default-export
export default fileNameToSafeString;
